import {
  PluginCurrencySchema_2023_08_20,
  PluginCurrencyType_2023_08_20,
} from "./2023-08-20";

export const PluginCurrencySchema = PluginCurrencySchema_2023_08_20;
export type PluginCurrencyType = PluginCurrencyType_2023_08_20;
